import { render, staticRenderFns } from "./IdCardDetailsSection.vue?vue&type=template&id=d61330cc&"
import script from "./IdCardDetailsSection.vue?vue&type=script&lang=js&"
export * from "./IdCardDetailsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports